import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
import { getErrMessages } from 'src/app/utils/errorHandler';
import { removeToken } from 'src/app/services/localStorage';
import { logout } from '../auth';
import { showMessage } from '../core/messageSlice';

export const getProfileInfo = createAsyncThunk(
  'profile/info',
  async ({ _request, props = [] }, { dispatch, getState, rejectWithValue }) => {
    const { user } = getState();
    if (typeof _request !== 'function') {
      const errorMessage = '_request must be a function';
      console.error(errorMessage);
      return rejectWithValue([errorMessage]);
    }
    try {
      const response = await _request(...props);
      if (!response || !response.data) {
        return user;
      }
      const data = await response.data;
      const dataFiltered = _.omit(data, ['updated_at', 'created_at', 'deleted_at']);
      return _.merge({}, user, dataFiltered);
    } catch (error) {
      const errArray = getErrMessages(error);
      const message = errArray.join();
      dispatch(showMessage({ message }));

      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        removeToken();
        dispatch(logout());
        errArray.unshift(`${error.response.status}`);
      }

      return rejectWithValue(errArray);
    }
  }
);
